import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { toastErrorLog } from '../../../helpers/toastErrorLog'

import {
  recibirUrlAutorizacion,
  recibirUserInfo
} from '../../servicios/mercadoPagoService'
import styles from './VincularMercadoPago.module.css'

export const VincularMercadoPago = ({ idUsuario }) => {
  const [authUrl, setAuthUrl] = useState('')
  const [loading, setLoading] = useState(true)
  const [userMP, setUserMP] = useState('')

  const fetchAuthUrl = async () => {
    try {
      const { data } = await recibirUrlAutorizacion({ idUsuario })
      setAuthUrl(data.body.url)
    } catch (error) {
      const mensaje = `Ocurrió un error al obtener la URL de autorización de Mercado Pago.`
      toastErrorLog(error, mensaje, 'mercadoPago')
    } finally {
      setLoading(false)
    }
  }

  const fetchUserInfo = async () => {
    try {
      const { data } = await recibirUserInfo({ idVendedor: idUsuario })
      setUserMP(`${data.body.first_name} ${data.body.last_name}(${data.body.nickname})`)
    } catch {
      toast.info('No se encontró usuario asociado de MP')
    }
  }

  useEffect(() => {
    fetchAuthUrl()
    fetchUserInfo()
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h4 className={styles.title}>Mercado Pago</h4>

        <p className={styles.description}>
          Vinculá tu cuenta para poder recibir pagos de forma automática.
        </p>

        <div className={styles.mpUser}>
          <a
            href={loading ? undefined : authUrl}
            className={`${styles.button} ${loading ? styles.buttonDisabled : ''}`}
            aria-disabled={loading}
          >
            {loading ? 'Cargando...' : 'Vincular cuenta'}
          </a>
          <div>
            Usuario vinculado:
            {userMP === '' ? (
              <span className={styles.statusVoid}> No tiene cuenta vinculada</span>
            ) : (
              <span className={styles.status}> {userMP}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

VincularMercadoPago.propTypes = {
  idUsuario: PropTypes.number.isRequired
}
